module.exports = __webpack_public_path__ + "img/fontSizeReduce.0b0e19cb.svg";